import { render } from "./RedeDeEnsinoPerfilDados.vue?vue&type=template&id=48e5d726&scoped=true&ts=true"
import script from "./RedeDeEnsinoPerfilDados.vue?vue&type=script&lang=ts"
export * from "./RedeDeEnsinoPerfilDados.vue?vue&type=script&lang=ts"

import "./RedeDeEnsinoPerfilDados.vue?vue&type=style&index=0&id=48e5d726&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48e5d726"]])

export default __exports__